import Ellipsis                     from 'ftellipsis';

import initModernizr                from './modernizr/modernizr';

import initNavigation               from './components/navigation';
import initSidebar                  from './components/sidebar';
import initAccordions               from './components/accordion';
import initSearch                   from './components/search';
import initForm                     from './components/form';
import {refreshRellax, initRellax}  from './components/rellax';

import 'scroll-depth';

$(() => {
    // init all components
    initNavigation();
    initSidebar();
    initAccordions();
    initSearch();
    initForm();
    initRellax();

    $('.js-ellipsis').each((index, element) => {
        var ellipsis = new Ellipsis(element);
        ellipsis.calc();
        ellipsis.set();
    });

    $('.cookie-alert .btn--ok, .cookie-alert .btn--settings:not(.disabled-closing)').on('click', (e) => {
        const $alert = $(e.target).closest('.cookie-alert');
        $alert.fadeOut(() => {
            $alert.find('.cookie-alert_header').removeClass('video share map')
        })
    })

    // Init moderznizr
    initModernizr();

    // Init scroll tracking
    jQuery.scrollDepth();

    recalculateViewportHeight();
});

function recalculateViewportHeight() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

window.addEventListener('load', (event) => {
    refreshRellax();
});

window.addEventListener('resize', (event) => {
    recalculateViewportHeight();
});


